module.exports = __webpack_public_path__ + "img/collection_bug.f540df76.png";